import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { RestaurantSelectionComponent } from './restaurant-selection.component';



@NgModule({
  declarations: [
    RestaurantSelectionComponent,
  ],
  exports:[
    RestaurantSelectionComponent
  ],
  imports: [
    SharedModule,
    CommonModule
  ],
})
export class RestaurantSelectionModule { }
